export default __webpack_public_path__ + "static/hero Image-084597c26ab29e3eabb2603f82d262f5.svg";